const es = {
  translation: {
    // Common
    common: {
      loading: 'Cargando...',
      saving: 'Guardando...',
      uploading: 'Subiendo...',
      error: 'Ocurrió un error',
      success: 'Formulario enviado exitosamente',
      updateSuccess: 'Datos actualizados exitosamente',
      addSuccess: 'Elemento agregado exitosamente',
      deleteSuccess: 'Elemento eliminado exitosamente',
      changesSaved: 'Cambios guardados exitosamente',
      errorSaving: 'Error al guardar cambios',
      you: 'Tú',
      save: 'Guardar',
      cancel: 'Cancelar',
      delete: 'Eliminar',
      edit: 'Editar',
      add: 'Agregar',
      search: 'Buscar...',
      noResults: 'No se encontraron resultados',
      required: 'Requerido',
      optional: 'Opcional',
      back: 'Atrás',
      next: 'Siguiente',
      previous: 'Anterior',
      change: 'Cambiar',
      finish: 'Finalizar',
      submit: 'Enviar',
      confirm: 'Confirmar',
      yes: 'Sí',
      no: 'No',
      date: 'Fecha',
      approved: 'Aprobado',
      rejected: 'Rechazado',
      pending: 'Pendiente',
      certApproved: 'Certificación aprobada',
      certRejected: 'Certificación rechazada',
      actions: 'Acciones',
      download: 'Descargar',
      retry: 'Reintentar',
      copy: 'Copiar',
      copied: 'Copiado',
      share: 'Compartir',
      showQR: 'Mostrar QR',
      hideQR: 'Ocultar QR',
      employee: 'Empleado',
      worker: 'Trabajador',
      business: 'Business',
    },

    // Errors
    errors: {
      fetchClients: 'Error al cargar los clientes',
      updateClient: 'Error al actualizar cliente',
      onlyPngAllowed: 'Solo se permiten archivos PNG',
      fileTooLarge: 'El archivo es demasiado grande (máx. 2MB)',
      logoUpload: 'Error al subir el logo',
      logoRemove: 'Error al eliminar el logo',
      contactNameEmailRequired: 'El nombre y email del contacto son requeridos',
    },

    // Notifications
    notifications: {
      certificationApproved: 'Certificación Aprobada',
      certificationRejected: 'Certificación Rechazada',
      workerApproved: 'Perfil Aprobado',
      workerRejected: 'Perfil Rechazado',
      profilePhotoRejected: 'Foto de Perfil Rechazada',
      identificationRejected: 'Identificación Rechazada',
      addressRejected: 'Dirección Rechazada',
      certificationApprovedMessage: 'Su certificación "{{certificationName}}" ha sido aprobada exitosamente.',
      certificationRejectedMessage: 'Su certificación "{{certificationName}}" ha sido rechazada. Motivo: {{reason}}',
      workerApprovedMessage: 'Su perfil de trabajador ha sido aprobado. Ya puede recibir asignaciones de trabajo.',
      workerRejectedMessage: 'Su perfil de trabajador ha sido rechazado. Motivo: {{reason}}',
      profilePhotoRejectedMessage: 'Su foto de perfil ha sido rechazada. Deberá subir una nueva foto. Motivo: {{reason}}',
      identificationRejectedMessage: 'Su identificación ha sido rechazada. Deberá subir nuevos documentos de identificación. Motivo: {{reason}}',
      addressRejectedMessage: 'Su dirección ha sido rechazada. Deberá proporcionar una nueva dirección. Motivo: {{reason}}',
      noReasonProvided: 'No se proporcionó un motivo específico',
      reviewNotes: 'Notas de Revisión',
      reviewNotesOptional: 'Notas de Revisión (Opcional)',
      reviewNotesRecommended: 'Notas de Revisión (Recomendado)',
      addReviewComments: 'Agregar comentarios sobre la revisión...',
      explainRejectionReason: 'Explica el motivo del rechazo...',
      cancel: 'Cancelar',
      approve: 'Aprobar',
      reject: 'Rechazar',
    },

    // User Blocked
    userBlocked: {
      title: 'Cuenta Bloqueada',
      subtitle: 'Su cuenta ha sido suspendida temporalmente',
      message: 'Su cuenta ha sido bloqueada. Motivo: {{reason}}',
      blockReason: 'Motivo del bloqueo',
      noReasonProvided: 'No se proporcionó un motivo específico',
      blockedAt: 'Fecha de bloqueo',
      blockedBy: 'Bloqueado por',
      administrator: 'Administrador del sistema',
      needHelp: '¿Necesita ayuda?',
      contactSupport: 'Si cree que esto es un error o desea apelar la decisión, por favor contacte al soporte técnico.',
      thankYou: 'Gracias por su comprensión'
    },

    // Admin
    admin: {
      approvalProcess: {
        title: 'Aprobación de Workers',
        name: 'Nombre',
        email: 'Email',
        createdAt: 'Fecha de Registro',
        actions: 'Acciones',
        view: 'Ver',
        profileReview: 'Revisión de Perfil',
        status: 'Estado',
        verificationStatus: 'Estado de Verificación',
        'verificationStatus.approved': 'Usuario aprobado exitosamente',
        'verificationStatus.rejected': 'Usuario rechazado',
        language: 'Idioma',
        onBoarding: 'OnBoarding',
        address: 'Dirección',
        identification: 'Identificación',
        type: 'Tipo',
        number: 'Número',
        certifications: 'Certificaciones',
        certification: 'Certificación',
        issuer: 'Emisor',
        date: 'Fecha',
        viewCertificate: 'Ver Certificado',
        noCertifications: 'Sin certificaciones',
        experience: 'Experiencia',
        noSkills: 'Sin habilidades',
        approve: 'Aprobar',
        reject: 'Rechazar',
        rejectionDetails: 'Detalles de Rechazo',
        rejectProfilePhoto: 'Rechazar Foto',
        rejectIdentification: 'Rechazar ID',
        rejectAddress: 'Rechazar Dirección',
        approveAddress: 'Aprobar Dirección',
        approveIdentification: 'Aprobar ID',
        blockUser: 'Bloquear Usuario',
        unblockUser: 'Desbloquear Usuario',
        tabs: {
          all: 'Todos',
          new: 'Nuevos',
          approved: 'Aprobados',
          pending: 'Pendientes',
          rejected: 'Rechazados',
          blocked: 'Bloqueados',
          certificationsPending: 'Certificaciones Pendientes'
        }
      }
    },

    // Onboarding Status
    onboardingStatus: {
      completed: 'Completado',
      notStarted: 'No iniciado',
      inProgress: 'En progreso',
      pending: 'Pendiente de revisión',
      rejected: 'Rechazado',
      steps: 'Pasos',
      progress: 'Progreso OnBoarding',
      completedSteps: 'Pasos Completados',
    },

    // Worker Dashboard
    workerDashboard: {
      loading: 'Cargando...',
      errorLoadingDashboard: 'Error al cargar datos del dashboard',
      notifications: 'Notificaciones',
      closeNotifications: 'Cerrar notificaciones',
      noNotifications: 'No tienes nuevas notificaciones.',
      myProfile: 'Mi Perfil',
      myProjects: 'Mis Proyectos',
      myCertifications: 'Mis Certificaciones',
      myAgenda: 'Mi Agenda',
      viewCertification: 'Ver Certificación',
      issuer: 'Emisor',
      issueDate: 'Fecha de Emisión',
      approved: 'Aprobado',
      rejected: 'Rechazado',
      pending: 'Pendiente',
      date: 'Fecha',
      certApproved: 'Certificación aprobada',
      certRejected: 'Certificación rechazada',
      // Certification statuses
      certificationApproved: '✅ Aprobada',
      certificationRejected: '❌ Rechazada',
      certificationPending: '⏳ Pendiente',
      // Project statuses
      projectActive: 'Activo',
      projectCompleted: 'Completado',
      // Project info
      myPayment: 'Mi pago',
      myTasks: 'Mis tareas',
      myProgress: 'Mi progreso',
    },

    workerProjectView: {
      myTasks: 'Mis Tareas',
      myProgress: 'Mi Progreso',
      myPayment: 'Mi Pago',
      duration: 'Duración',
      days: 'días',
      projectDates: 'Fechas del Proyecto',
      startDate: 'Fecha de Inicio',
      endDate: 'Fecha de Fin',
      location: 'Ubicación',
      generalProgress: 'Mi Progreso General',
      myTasksInProject: 'Mis Tareas en este Proyecto',
      noTasksAssigned: 'No tienes tareas asignadas a este proyecto',
      checklistProgress: 'Progreso del Checklist',
      taskLocation: 'Ubicación de la Tarea',
      checklist: 'Checklist',
      tabs: {
        tasks: 'Mis Tareas',
        notes: 'Notas'
      }
    },

    // Employee Dashboard
    employeeDashboard: {
      welcome: 'Bienvenido',
      totalTasks: 'Total Tareas',
      completedTasks: 'Tareas Completadas',
      totalHours: 'Horas Totales',
      activeProjects: 'Proyectos Activos',
      taskCompletion: 'Completación de Tareas',
      productivity: 'Productividad Semanal',
      recentTasks: 'Tareas Recientes',
      viewAll: 'Ver todas',
      noTasks: 'No hay tareas asignadas',
      noProjects: 'No hay proyectos activos',
      linkageModal: {
        title: 'Código de Vinculación Dinámico',
        description: 'Muestra este código dinámico a tu empresa para establecer la conexión.',
        instructions: 'Instrucciones:',
        step1: 'Muestra este código a tu administrador de empresa',
        step2: 'La empresa escaneará tu código dinámico',
        step3: 'Una vez escaneado, serás asignado automáticamente a la empresa',
        step4: 'Tu panel se actualizará con las funciones de la empresa',
        close: 'Cerrar'
      },
      unreadTab: 'Sin leer',
      readTab: 'Leídas'
    },

    // Dynamic Linkage Code
    dynamicLinkageCode: {
      refreshesEvery30s: 'Se actualiza cada 30 segundos',
      scanning: 'Escaneando para conexión...',
      instructions: 'Este código dinámico es escaneable por cualquier aplicación de escáner de códigos de barras. Muéstralo a tu administrador de empresa.'
    },

    // Employee Register
    employeeRegister: {
      title: 'Registro de Empleado',
      phone: 'Teléfono',
      phonePlaceholder: '+1 (555) 123-4567',
      employeeId: 'ID de Empleado',
      employeeIdPlaceholder: 'EMP-001',
      department: 'Departamento',
      selectDepartment: 'Selecciona un departamento',
      position: 'Posición',
      selectPosition: 'Selecciona una posición',
      hireDate: 'Fecha de Contratación',
      fillAllFields: 'Por favor completa todos los campos requeridos',
      creating: 'Creando cuenta...',
      register: 'Registrarse como Empleado',
      alreadyHaveAccount: '¿Ya tienes una cuenta?',
      signIn: 'Inicia sesión',
      error: 'Error al crear la cuenta de empleado'
    },

    // Thank You Page
    thankYou: {
      title: '¡Gracias por tu solicitud!',
      message: 'Hemos recibido tu solicitud de cotización. Nuestro equipo la revisará y te contactará pronto con los detalles.'
    },

    // Error messages
    error: {
      submittingForm: 'Error al enviar el formulario. Por favor, inténtalo de nuevo.'
    },

    // Projects
    projects: {
      title: 'Proyectos',
      create: 'Crear Proyecto',
      searchPlaceholder: 'Buscar proyectos...',
      filter: 'Estado',
      client: 'Cliente',
      totalAmount: 'Monto Total',
      startDate: 'Fecha de Inicio',
      notStarted: 'No Iniciado',
      status: {
        active: 'Activo',
        completed: 'Completado',
        onHold: 'En Pausa',
        cancelled: 'Cancelado'
      },
      empty: 'No hay proyectos registrados para este negocio. ¡Crea tu primer proyecto haciendo clic en "Crear Proyecto"!',
      noResults: 'No se encontraron proyectos',
      adjustFilters: 'Intenta ajustar los filtros de búsqueda',
      startCreating: 'Comienza creando tu primer proyecto',
      allStatuses: 'Todos los estados',
      allClients: 'Todos los clientes',
      unknownClient: 'Cliente desconocido',
      name: 'Nombre',
      descriptionPlaceholder: 'Describe el proyecto...',
      selectClient: 'Seleccionar cliente',
      endDate: 'Fecha de Fin',
      created: 'Proyecto creado exitosamente',
      validation: {
        required: 'Por favor completa todos los campos requeridos'
      },
      pagination: {
        prev: 'Anterior',
        next: 'Siguiente',
        page: 'Página',
        of: 'de'
      },
      progress: 'Progreso',
      createdOn: 'Creado el',
      projectRegistered: 'proyecto registrado',
      projectsRegistered: 'proyectos registrados',
      startCreatingMessage: 'Comienza creando tu primer proyecto para gestionar tareas y recursos',
      createFirst: 'Crear primer proyecto',
      viewTitle: 'Detalles del Proyecto',
      viewIdLabel: 'ID del Proyecto',
      notFound: 'Proyecto no encontrado',
      sidebar: {
        project: 'Proyecto'
      },
      notes: {
        title: 'Notas del Proyecto',
        writeNote: 'Escribe una nota...',
        placeholder: 'Escribe una nota...',
        addNote: 'Agregar Nota',
        saving: 'Guardando...',
        noNotes: 'Aún no hay notas.',
      },
      tabs: {
        info: 'Información',
        client: 'Cliente',
        tasks: 'Tareas',
        staff: 'Personal',
        documents: 'Documentos',
        materials: 'Materiales',
        services: 'Servicios',
        finances: 'Finanzas',
        notes: 'Notas',
        addStaff: 'Agregar Personal',
        noStaff: 'No hay personal asignado aún',
        addStaffDescription: 'Agrega trabajadores o empleados a este proyecto',
        filterRole: 'Todos los Roles',
        filterSkill: 'Filtrar por habilidad',
        filterCert: 'Filtrar por certificación',
        filterCity: 'Filtrar por ciudad',
        assignWorker: 'Asignar Trabajador'
      },
      staff: {
        addSelf: 'Añadirme al equipo',
        addSelfTitle: 'Añadirme al equipo del proyecto',
        addSelfDescription: 'Selecciona tu rol en este proyecto:',
        addSelfButton: 'Añadirme al equipo',
        selfAdded: 'Te has añadido exitosamente al equipo del proyecto',
        alreadyAdded: 'Ya estás agregado al equipo del proyecto',
        errorAddingSelf: 'Error al añadirte al equipo',
        projectManagerDesc: 'Gestiona y supervisa todo el proyecto',
        supervisorDesc: 'Supervisa el trabajo en campo y calidad',
        editRole: 'Editar rol',
        assignRole: 'Asignar rol',
        editRoleTitle: 'Asignar rol en el proyecto',
        member: 'Miembro',
        selectRole: 'Selecciona el rol en este proyecto:',
        updateRole: 'Actualizar rol',
        roleUpdated: 'Rol actualizado exitosamente',
        errorUpdatingRole: 'Error al actualizar el rol',
        remove: 'Eliminar del equipo',
        confirmRemove: '¿Estás seguro de eliminar este miembro del equipo?',
        memberRemoved: 'Miembro eliminado del equipo',
        errorRemoving: 'Error al eliminar miembro',
        noRole: 'Sin rol específico',
        noRoleDesc: 'Miembro del equipo sin rol definido',
        tasksAssigned: 'tareas asignadas',
        memberDetails: 'Detalles del Miembro',
        memberDetailsDesc: 'Información y permisos del miembro del equipo',
        memberInfo: 'Información del Miembro',
        skills: 'Habilidades',
        projectRole: 'Rol en el Proyecto',
        projectRoleDesc: 'Define la función específica de este miembro en el proyecto',
        signaturePermission: 'Permiso de Firma',
        signaturePermissionDesc: 'Permite que este miembro pueda firmar reportes de scanning jobs en tu nombre',
        canSignForMe: 'Puede firmar por mí',
        canSignForMeDesc: 'Este usuario podrá firmar reportes de scanning en tu nombre cuando sea necesario',
        memberUpdated: 'Miembro actualizado exitosamente',
        errorUpdating: 'Error al actualizar miembro',
        othersWhoGrantedPermission: 'Otros usuarios que han dado permiso'
      },
      info: {
        status: 'Estado',
        amount: 'Monto',
        startDate: 'Fecha de Inicio',
        endDate: 'Fecha de Fin',
        progress: 'Progreso',
        description: 'Descripción',
        createdAt: 'Creado el',
        viewHistory: 'Ver historial',
        name: 'Nombre',
        services: 'Servicios',
        quotation: 'Cotización'
      },
      documents: {
        upload: 'Subir Documento',
        dragAndDrop: 'Arrastra y suelta documentos aquí, o haz clic para seleccionar',
        supportedFormats: 'Formatos soportados: PDF, DOC, XLS, imágenes',
        maxFileSize: 'Tamaño máximo: 10MB',
        uploading: 'Subiendo...',
        download: 'Descargar',
        delete: 'Eliminar',
        noDocuments: 'No hay documentos',
        uploadSuccess: 'Documento subido exitosamente',
        uploadError: 'Error al subir documento',
        deleteSuccess: 'Documento eliminado exitosamente'
      },
      materials: {
        name: 'Nombre',
        description: 'Descripción',
        quantity: 'Cantidad',
        unit: 'Unidad',
        price: 'Precio',
        total: 'Total',
        noData: 'No se encontraron materiales.',
        add: 'Agregar Material',
        edit: 'Editar Material'
      },
      services: {
        name: 'Nombre',
        description: 'Descripción',
        quantity: 'Cantidad',
        unit: 'Unidad',
        price: 'Precio',
        total: 'Total',
        noData: 'No se encontraron servicios.',
        add: 'Agregar Servicio',
        edit: 'Editar Servicio'
      },
      kanban: {
        uploadingFiles: 'Subiendo archivos...',
        scanningJob: {
          title: '¿Es un Trabajo de Escaneo?',
          description: 'Activa esta opción si esta tarea incluye trabajo de escaneo de concreto',
          purpose: 'Propósito',
          equipment: 'Equipo',
          process: 'Proceso',
          limitations: 'Limitaciones',
          findings: 'Hallazgos',
          closure: 'Cierre',
          report: 'Reporte de Trabajo de Escaneo',
          generateReport: 'Generar Reporte',
          checklist: {
            structuralReinforcement: {
              title: 'A. Refuerzo Estructural',
              rebarDetected: 'Varilla detectada',
              wireMeshDetected: 'Malla de alambre detectada',
              postTensionTendons: 'Tendones de postensado detectados',
              noReinforcement: 'No se detectó refuerzo en el área escaneada'
            },
            detectedUtilities: {
              title: 'B. Utilidades Detectadas',
              electricalConduit: 'Conducto eléctrico',
              communicationsConduit: 'Conducto de comunicaciones',
              metalPipe: 'Tubería metálica',
              pvcPipe: 'Tubería PVC',
              energizedUtilities: 'Utilidades energizadas detectadas (lecturas EM)',
              noUtilities: 'No se detectaron utilidades'
            },
            slabConditions: {
              title: 'C. Condiciones de la Losa',
              highMoisture: 'Niveles altos de humedad en la losa',
              interference: 'Interferencia en las señales',
              limitedDepth: 'Penetración de profundidad limitada',
              irregularSurface: 'Superficie irregular afectó el escaneo'
            },
            surfaceMarkings: {
              title: 'D. Marcas en la Superficie',
              markedRed: 'Marcado en rojo (eléctrico)',
              markedYellow: 'Marcado en amarillo (refuerzo)',
              highRiskAreas: 'Áreas de alto riesgo marcadas',
              manualExposure: 'Se requiere exposición manual antes de perforar/cortar'
            },
            recommendations: {
              title: 'E. Recomendaciones',
              avoidDrilling: 'Evitar perforar cerca de áreas marcadas',
              manuallyExpose: 'Exponer manualmente los elementos marcados antes de cortar',
              reviewDrawings: 'Revisar los planos estructurales',
              recommendRescan: 'Recomendación de re-escaneo debido a interferencia'
            }
          }
        }
      },
      assignment: {
        worker: 'Trabajador',
        amount: 'Monto',
        total: 'Total',
        status: 'Estado',
        statuses: {
          pending: 'Pendiente',
          accepted: 'Aceptado',
          rejected: 'Rechazado',
          counter: 'Contraoferta',
          removed: 'Removido'
        },
        startDate: 'Fecha de inicio',
        duration: 'Duración',
        perHour: 'por hora',
        perDay: 'por día',
        accept: 'Aceptar',
        reject: 'Rechazar',
        sending: 'Enviando...',
        sendCounteroffer: 'Enviar contraoferta',
        workerCounteroffer: 'Contraoferta del trabajador',
        price: 'Precio'
      },
      finances: {
        title: 'Finanzas del Proyecto',
        budget: 'Presupuesto',
        totalExpenses: 'Gastos Totales',
        netProfit: 'Beneficio Neto',
        expenseBreakdown: 'Desglose de Gastos',
        materials: 'Materiales',
        services: 'Servicios',
        labor: 'Mano de Obra',
        overhead: 'Gastos Generales',
        other: 'Otros',
        total: 'Total',
        taxes: 'Impuestos',
        transactions: 'Transacciones',
        addIncome: 'Agregar Ingreso',
        addExpense: 'Agregar Gasto',
        loading: 'Cargando transacciones...',
        noTransactions: 'No hay transacciones registradas',
        startTracking: 'Comienza a registrar tus ingresos y gastos',
        date: 'Fecha',
        description: 'Descripción',
        category: 'Categoría',
        amount: 'Monto',
        actions: 'Acciones',
        status: {
          title: 'Estado',
          pending: 'Pendiente',
          paid: 'Pagado',
          cancelled: 'Cancelado'
        },
        markAsPaid: 'Marcar como Pagado',
        viewReceipt: 'Ver comprobante',
        markAsPaidModal: {
          title: 'Marcar como Pagado',
          transaction: 'Transacción',
          amount: 'Monto',
          attachReceipt: 'Adjuntar comprobante (PDF o imagen)',
          cancel: 'Cancelar',
          confirm: 'Confirmar Pago',
          saving: 'Guardando...',
          processing: 'Procesando...'
        }
      },
      workerAssignment: {
        title: 'Asignación de trabajador',
        searchPlaceholder: 'Buscar por nombre, email, ciudad o habilidad...',
        skills: 'Habilidades',
        certifications: 'Certificaciones',
        noWorkers: 'No hay trabajadores activos disponibles.',
        offerButton: 'Ofertar',
        offerTitle: 'Oferta para {{name}}',
        price: 'Precio ofrecido',
        unit: 'Unidad',
        selectUnit: 'Seleccionar unidad',
        hour: 'Hora',
        day: 'Día',
        duration: 'Duración',
        sendOffer: 'Enviar oferta',
        offerSent: 'Oferta enviada exitosamente',
        offerError: 'Error al enviar oferta',
        completeAllFields: 'Por favor completa todos los campos',
        workerAssigned: 'Trabajador asignado exitosamente a la tarea',
        assignmentRequests: 'Solicitudes de asignación',
        sendMoreOffers: 'Enviar más ofertas',
        viewHistory: 'Ver historial',
        currentlyAssigned: 'Trabajadores actualmente asignados',
        assignNewWorker: 'Asignar Nuevo Worker',
        workersAlreadyAssigned: 'Ya tienes workers asignados a esta tarea',
        removeWorkerToAssign: 'Quita un worker para poder asignar uno nuevo',
      },
      deleteTask: {
        cannotDelete: 'No puedes eliminar esta tarea',
        hasWorkerAssigned: 'Esta tarea tiene un worker contratado.',
        workerProtection: 'Para proteger los derechos del worker, no puedes eliminar una tarea que ya ha sido aceptada.',
        removeWorkerFirst: 'Debes remover primero al worker asignado o cancelar la asignación.',
        understood: 'Entendido'
      },
      history: {
        title: 'Historial del Proyecto',
        project: 'Proyecto',
        export: 'Exportar CSV',
        filter: 'Filtrar por acción',
        all: 'Todas',
        records: 'Registros',
        project_updated: 'Proyecto actualizado',
        project_created: 'Proyecto creado',
        project_upload: 'Subida de proyecto',
        task_created: 'Tarea creada',
        task_deleted: 'Tarea eliminada',
        task_updated: 'Tarea actualizada',
        worker_assigned: 'Trabajador asignado',
        worker_removed: 'Trabajador removido',
        offer_sent: 'Oferta enviada',
        offer_accepted: 'Oferta aceptada',
        offer_rejected: 'Oferta rechazada',
        counter_offer: 'Contraoferta',
        location_updated: 'Ubicación actualizada',
        checklist_updated: 'Checklist actualizado',
        details_updated: 'Detalles actualizados',
        worker_updated: 'Trabajador actualizado',
        performedBy: 'Realizado por',
        documentsChanged: 'Documentos modificados',
        materialChanged: 'Material modificado',
        fieldChanged: 'Campo modificado',
        newValue: 'Nuevo valor',
        noHistory: 'No hay historial',
        noHistoryMessage: 'No se encontraron registros de actividad para este proyecto.',
        loadingHistory: 'Cargando historial...',
        errorMissingData: 'Faltan datos de usuario o proyecto',
        changeDetails: 'Detalles del cambio',
        changes: 'Cambios realizados',
        summary: {
          project_created: 'Proyecto creado',
          document_uploaded: 'Documento subido',
          material_added: 'Material agregado',
          material_deleted: 'Material eliminado',
          material_edited: 'Material editado',
          name_changed: 'Nombre del proyecto cambiado',
          description_changed: 'Descripción cambiada',
          client_changed: 'Cliente cambiado',
          columns_changed: 'Columnas cambiadas',
          document_deleted: 'Documento eliminado',
          project_updated: 'Proyecto actualizado',
          task_created: 'Tarea creada',
          task_deleted: 'Tarea eliminada',
          worker_assigned: 'Trabajador asignado',
          worker_removed: 'Trabajador removido',
          task_updated: 'Tarea actualizada',
          offer_sent: 'Oferta enviada',
          offer_accepted: 'Oferta aceptada',
          offer_rejected: 'Oferta rechazada',
          counter_offer: 'Contraoferta',
          location_updated: 'Ubicación actualizada',
          checklist_updated: 'Checklist actualizado',
          details_updated: 'Detalles actualizados',
          worker_updated: 'Trabajador actualizado',
          generic: 'Actividad del proyecto',
        }
      }
    },

    // Menu translations
    menu: {
      title: 'Menú',
      close: 'Cerrar',
      dashboard: 'Dashboard',
      profile: 'Perfil',
      logout: 'Cerrar Sesión',
      quotations: 'Cotizaciones',
      projects: 'Proyectos',
      myBusiness: 'Mi Negocio',
      businessAgenda: 'Agenda',
      workerAgenda: 'Mi Agenda',
      jobHistory: 'Historial de Trabajos',
      worker: {
        dashboard: 'Dashboard',
        balance: 'Balance',
      },
      employee: {
        dashboard: 'Dashboard de Empleado',
        tasks: 'Mis Tareas',
        projects: 'Mis Proyectos',
        timesheet: 'Hoja de Tiempo',
      },
      admin: {
        dashboard: 'Dashboard',
        skills: 'Gestión de Habilidades',
        userPasswords: 'Gestión de Contraseñas',
      },
      business: {
        information: 'Información',
        clients: 'Clientes',
        addClient: 'Nuevo cliente',
        editClient: 'Editar cliente',
        noClients: 'No hay clientes registrados',
        generalInfo: 'Información General',
        location: 'Ubicación',
        logo: 'Logo',
        clientName: 'Nombre del cliente',
        clientNamePlaceholder: 'Ingrese el nombre',
        clientEmail: 'Email',
        clientEmailPlaceholder: 'ejemplo@correo.com',
        clientPhone: 'Teléfono',
        clientPhonePlaceholder: '+1234567890',
        clientAddress: 'Dirección',
        clientAddressPlaceholder: 'Calle, ciudad, país',
        addressHelp: 'Ingrese la dirección completa del cliente para facilitar la ubicación y gestión de proyectos.',
        logoUrl: 'URL del Logo',
        logoUrlPlaceholder: 'https://ejemplo.com/logo.png',
        logoHelp: 'Puede agregar el logo del cliente para personalizar documentos y reportes.',
      uploadLogo: 'Subir Logo (PNG)',
      changeLogo: 'Cambiar Logo (PNG)',
      removeLogo: 'Eliminar logo',
      logoRequirements: 'Requisitos del logo:',
      logoFormatPng: 'Formato: PNG únicamente',
      logoMaxSize: 'Tamaño máximo: 2MB',
      logoRecommendation: 'Recomendado: Fondo transparente, 500x500px',
      contacts: 'Contactos',
      existingContacts: 'Contactos registrados',
      addNewContact: 'Agregar nuevo contacto',
      addContact: 'Agregar contacto',
      noContacts: 'No hay contactos registrados',
      addFirstContact: 'Agrega el primer contacto arriba',
      contactName: 'Nombre',
      contactNamePlaceholder: 'Nombre del contacto',
      contactEmail: 'Email',
      contactEmailPlaceholder: 'email@ejemplo.com',
      contactPhone: 'Teléfono',
      contactPhonePlaceholder: '+1234567890',
      contactLinkedin: 'LinkedIn URL',
      contactDetails: 'Detalles del contacto',
      contactInfo: 'Información',
      viewProfile: 'Ver perfil',
      linkedinProfileMessage: 'Perfil profesional en LinkedIn',
      openLinkedIn: 'Abrir en LinkedIn',
      confirmDeleteContact: '¿Eliminar este contacto?',
      clientRegistered: 'cliente registrado',
      clientsRegistered: 'clientes registrados',
      addFirstClientMessage: 'Comienza agregando tu primer cliente para gestionar proyectos y contactos',
      addFirstClient: 'Agregar primer cliente',
      contact: 'contacto',
      contactsPlural: 'contactos',
      addedOn: 'Agregado',
      dateNotAvailable: 'Fecha no disponible',
      },
      settings: 'Configuración',
    },

    // Roster
    roster: {
      title: 'Plantilla',
      registrationCode: 'Código de Registro',
      codeDescription: 'Comparte este código con tus empleados para que puedan registrarse en tu empresa.',
      currentCode: 'Código actual',
      copyCode: 'Copiar código',
      generateCode: 'Generar código',
      regenerateCode: 'Regenerar código',
      generating: 'Generando...',
      noCodeYet: 'Aún no has generado un código de registro',
      codeGenerated: 'Código generado exitosamente',
      errorGeneratingCode: 'Error al generar el código',
      registrationLink: 'Link de registro',
      copyRegistrationLink: 'Copiar link de registro',
      linkCopied: 'Link copiado al portapapeles',
      employees: 'Empleados',
      employee: 'empleado',
      employeesPlural: 'empleados',
      noEmployees: 'No hay empleados registrados',
      shareRegistrationLink: 'Comparte el link de registro para que tus empleados se unan',
      approve: 'Aprobar',
      reject: 'Rechazar',
      employeeApproved: 'Empleado aprobado exitosamente',
      employeeRejected: 'Empleado rechazado',
      errorApprovingEmployee: 'Error al aprobar empleado',
      errorRejectingEmployee: 'Error al rechazar empleado',
      status: {
        pending: 'Pendiente',
        active: 'Activo',
        inactive: 'Inactivo'
      }
    },

    // Employee Registration
    employee: {
      joinTeam: 'Únete al equipo',
      personalInformation: 'Información Personal',
      firstName: 'Nombre',
      firstNamePlaceholder: 'Ingresa tu nombre',
      firstNameRequired: 'El nombre es requerido',
      lastName: 'Apellido',
      lastNamePlaceholder: 'Ingresa tu apellido',
      lastNameRequired: 'El apellido es requerido',
      email: 'Correo Electrónico',
      emailPlaceholder: 'tu@email.com',
      emailRequired: 'El correo electrónico es requerido',
      emailInvalid: 'El correo electrónico no es válido',
      emailAlreadyInUse: 'Este correo electrónico ya está en uso',
      phone: 'Teléfono',
      phonePlaceholder: '+1234567890',
      phoneRequired: 'El teléfono es requerido',
      title: 'Título',
      titlePlaceholder: 'Ej: Ingeniero, Doctor, etc.',
      titleRequired: 'El título es requerido',
      position: 'Cargo',
      positionPlaceholder: 'Ej: Gerente, Supervisor, etc.',
      positionRequired: 'El cargo es requerido',
      password: 'Contraseña',
      passwordPlaceholder: 'Mínimo 6 caracteres',
      passwordMinLength: 'La contraseña debe tener al menos 6 caracteres',
      passwordHelp: 'Mínimo 6 caracteres',
      registrationCode: 'Código de Registro',
      registrationCodePlaceholder: 'Código de 6 dígitos',
      registrationCodeRequired: 'El código de registro es requerido',
      registrationCodeHelp: 'Solicita este código a tu empleador',
      invalidRegistrationCode: 'Código de registro inválido',
      register: 'Registrarme',
      registering: 'Registrando...',
      registrationSuccess: '¡Registro Exitoso!',
      pendingApproval: 'Tu registro está pendiente de aprobación por parte de la empresa.',
      redirecting: 'Serás redirigido en unos momentos...',
      registrationError: 'Error al registrar. Por favor intenta nuevamente.',
      invalidLink: 'Link de registro inválido',
      businessNotFound: 'Empresa no encontrada',
      errorLoadingBusiness: 'Error al cargar información de la empresa'
    },

    // Welcome Screen
    welcome: {
      title: 'Bienvenido a Brix',
      subtitle: 'La plataforma que conecta trabajadores con oportunidades',
      login: 'Iniciar Sesión',
      register: 'Registrarse',
      chooseType: '¿Cómo quieres registrarte?',
      asWorker: 'Como Trabajador',
      asEmployee: 'Como Empleado',
      asBusiness: 'Como Negocio',
      chooseSector: '¿En qué sector se encuentra tu empresa?',
      sectorHealth: 'Sector Salud',
      sectorConstruction: 'Sector Construcción',
      close: 'Cerrar'
    },

    // Profile Page
    profile: {
      title: 'Mi Perfil',
      personalInfo: 'Información Personal',
      firstName: 'Nombre',
      lastName: 'Apellido',
      email: 'Correo Electrónico',
      phone: 'Teléfono',
      address: 'Dirección',
      street: 'Calle',
      city: 'Ciudad',
      state: 'Estado',
      zipCode: 'Código Postal',
      country: 'País',
      experience: 'Experiencia',
      yearsExperience: 'Años de Experiencia',
      years: 'años',
      description: 'Descripción',
      certifications: 'Certificaciones',
      addCertification: 'Agregar Certificación',
      newCertification: 'Nueva Certificación',
      certificationName: 'Nombre de la Certificación',
      issuer: 'Emisor',
      issueDate: 'Fecha de Emisión',
      expiryDate: 'Fecha de Vencimiento',
      certificationFile: 'Archivo de Certificación',
      certificationStatus: {
        approved: 'Aprobada',
        rejected: 'Rechazada',
        pending: 'Pendiente'
      },
      statistics: 'Estadísticas',
      totalEarnings: 'Ganancias Totales',
      completedJobs: 'Trabajos Completados',
      rating: 'Calificación',
      availableFunds: 'Fondos Disponibles',
      qrCode: 'Código QR',
      uploadingPhoto: 'Subiendo foto...',
      sectors: {
        health: 'Salud',
        construction: 'Construcción'
      },
      status: {
        active: 'Activo',
        pending: 'Pendiente'
      },
      error: {
        loading: 'Error al cargar el perfil',
        updating: 'Error al actualizar el perfil',
        photoUpload: 'Error al subir la foto',
        certificationUpload: 'Error al subir la certificación',
        certificationDelete: 'Error al eliminar la certificación',
        notFound: 'Perfil no encontrado',
        pdfGeneration: 'Error al generar el PDF',
        windowOpen: 'No se pudo abrir la ventana del perfil público'
      },
      success: {
        updated: 'Perfil actualizado exitosamente',
        photoUpdated: 'Foto actualizada exitosamente',
        certificationAdded: 'Certificación agregada exitosamente',
        certificationDeleted: 'Certificación eliminada exitosamente',
        pdfGenerated: 'PDF generado exitosamente'
      },
      identification: 'Identificación',
      idType: 'Tipo de Identificación',
      idNumber: 'Número de Identificación',
      frontImage: 'Imagen Frontal',
      backImage: 'Imagen Trasera',
      verificationStatus: 'Estado de Verificación',
      noIdentification: 'No hay información de identificación',
      driverLicense: 'Licencia de Conducir',
      passport: 'Pasaporte',
      nationalId: 'Cédula Nacional',
      other: 'Otro',
      personalDescription: 'Descripción Personal',
      personalDescriptionPlaceholder: 'Cuéntanos sobre ti, tus intereses, experiencia...',
                                viewPDF: 'Ver PDF',
      download: 'Descargar',
      retry: 'Reintentar',
      publicLink: {
        title: 'Enlace del Perfil Público',
        scanQR: 'Escanear para ver el perfil',
        info: 'Información del enlace público',
        noAuth: 'No requiere autenticación para ver',
        viewable: 'Cualquier persona puede ver el perfil',
        shareable: 'Puede ser compartido libremente'
      },
      digitalSignature: {
        title: 'Certificado de Firma Electrónica (.p12)',
        uploaded: 'Subido',
        status: {
          active: 'Activo',
          expired: 'Expirado',
          revoked: 'Revocado'
        },
        download: 'Descargar certificado',
        delete: 'Eliminar certificado',
        noCertificate: 'No hay certificado de firma electrónica cargado',
        uploadDescription: 'Sube tu certificado .p12 para poder firmar documentos digitalmente',
        uploadButton: 'Subir Certificado .p12',
        infoTitle: 'Información sobre certificados .p12',
        info1: 'El archivo .p12 es tu certificado de firma electrónica personal',
        info2: 'Este certificado te permite firmar documentos digitalmente',
        info3: 'Mantén tu certificado seguro y no lo compartas',
        info4: 'El certificado se almacena de forma segura y encriptada',
        errorInvalidFile: 'Por favor, selecciona un archivo .p12 o .pfx válido',
        uploadSuccess: 'Certificado de firma electrónica cargado y validado exitosamente',
        uploadError: 'Error al cargar el certificado de firma electrónica',
        confirmDelete: '¿Estás seguro de que deseas eliminar el certificado de firma electrónica?',
        deleteSuccess: 'Certificado eliminado exitosamente',
        deleteError: 'Error al eliminar el certificado',
        errorInvalidFormat: 'Formato de certificado inválido',
        errorInvalidPassword: 'Contraseña incorrecta. Inténtalo de nuevo.',
        errorNoCertificate: 'No se encontró ningún certificado en el archivo',
        errorExpired: 'Este certificado ha expirado y no puede ser utilizado',
        errorNotYetValid: 'Este certificado aún no es válido',
        passwordModal: {
          title: 'Contraseña del Certificado',
          description: 'Ingresa la contraseña para validar e importar tu certificado',
          password: 'Contraseña',
          passwordPlaceholder: 'Ingresa la contraseña del certificado',
          validate: 'Validar',
          validating: 'Validando...'
        },
        certInfo: {
          subject: 'Sujeto',
          organization: 'Organización',
          issuer: 'Emisor',
          validity: 'Validez',
          serial: 'Número de Serie'
        }
      }
    },

    // Job History Page
    jobHistory: {
      title: 'Historial de Trabajos',
      currentMonth: {
        title: 'Mes Actual',
        jobs: 'trabajos'
      },
      bestMonth: {
        title: 'Mejor Mes',
        jobs: 'trabajos'
      },
      filters: 'Filtros',
      filterStatus: 'Estado',
      filterDateRange: 'Rango de Fechas',
      filterBusiness: 'Empresa',
      filterMinAmount: 'Monto Mínimo',
      filterMaxAmount: 'Monto Máximo',
      dateRange: {
        week: 'Última Semana',
        month: 'Último Mes',
        quarter: 'Último Trimestre',
        year: 'Último Año'
      },
      status: {
        completed: 'Completado',
        cancelled: 'Cancelado',
        inProgress: 'En Progreso'
      },
      stats: {
        totalJobs: 'Total de Trabajos',
        totalEarnings: 'Ganancias Totales',
        averageJobValue: 'Valor Promedio por Trabajo',
        completionRate: 'Tasa de Finalización'
      },
      jobsList: 'Lista de Trabajos',
      noJobs: 'No hay trabajos completados',
      duration: 'Duración',
      rate: 'Tarifa',
      earnings: 'Ganancias',
      units: {
        hours: 'horas',
        days: 'días'
      },
      per: {
        hour: '/hora',
        day: '/día'
      },
      error: {
        loading: 'Error al cargar el historial'
      }
    },

    // Settings Page
    settings: {
      title: 'Configuración',
      tabs: {
        profile: 'Perfil',
        notifications: 'Notificaciones',
        privacy: 'Privacidad',
        work: 'Trabajo',
        app: 'Aplicación',
        security: 'Seguridad'
      },
      profile: {
        title: 'Información del Perfil',
        firstName: 'Nombre',
        lastName: 'Apellido',
        email: 'Correo Electrónico',
        phone: 'Teléfono',
        language: 'Idioma',
        changePassword: 'Cambiar Contraseña',
        newPassword: 'Nueva Contraseña',
        confirmPassword: 'Confirmar Contraseña',
        updatePassword: 'Actualizar Contraseña'
      },
      notifications: {
        title: 'Configuración de Notificaciones',
        email: 'Notificaciones por Email',
        emailDescription: 'Recibir notificaciones por correo electrónico',
        push: 'Notificaciones Push',
        pushDescription: 'Recibir notificaciones en el dispositivo',
        sms: 'Notificaciones SMS',
        smsDescription: 'Recibir notificaciones por mensaje de texto',
        newJobs: 'Nuevos Trabajos',
        newJobsDescription: 'Notificaciones sobre nuevas oportunidades de trabajo',
        jobUpdates: 'Actualizaciones de Trabajo',
        jobUpdatesDescription: 'Cambios en el estado de tus trabajos asignados',
        payments: 'Pagos',
        paymentsDescription: 'Notificaciones sobre pagos y transacciones',
        messages: 'Mensajes',
        messagesDescription: 'Nuevos mensajes de empresas o clientes',
        reminders: 'Recordatorios',
        remindersDescription: 'Recordatorios sobre trabajos pendientes'
      },
      privacy: {
        title: 'Configuración de Privacidad',
        profileVisibility: 'Visibilidad del Perfil',
        profileVisibilityDescription: 'Quién puede ver tu perfil',
        showLocation: 'Mostrar Ubicación',
        showLocationDescription: 'Permitir que las empresas vean tu ubicación',
        showEarnings: 'Mostrar Ganancias',
        showEarningsDescription: 'Mostrar tus ganancias en el perfil público',
        showRating: 'Mostrar Calificación',
        showRatingDescription: 'Mostrar tu calificación promedio',
        allowContact: 'Permitir Contacto',
        allowContactDescription: 'Permitir que las empresas te contacten directamente',
        dataSharing: 'Compartir Datos',
        dataSharingDescription: 'Compartir datos con terceros para mejorar el servicio',
        visibility: {
          public: 'Público',
          private: 'Privado',
          businesses: 'Solo Empresas'
        }
      },
      work: {
        title: 'Preferencias de Trabajo',
        maxDistance: 'Distancia Máxima',
        minHourlyRate: 'Tarifa Mínima por Hora',
        availability: 'Disponibilidad Semanal',
        days: {
          monday: 'Lunes',
          tuesday: 'Martes',
          wednesday: 'Miércoles',
          thursday: 'Jueves',
          friday: 'Viernes',
          saturday: 'Sábado',
          sunday: 'Domingo'
        }
      },
      app: {
        title: 'Configuración de la Aplicación',
        theme: 'Tema',
        themeDescription: 'Seleccionar el tema visual de la aplicación',
        soundEnabled: 'Sonidos Habilitados',
        soundEnabledDescription: 'Reproducir sonidos en la aplicación',
        vibrationEnabled: 'Vibración Habilitada',
        vibrationEnabledDescription: 'Vibración en notificaciones',
        autoLocation: 'Ubicación Automática',
        autoLocationDescription: 'Compartir ubicación automáticamente',
        dataUsageLabel: 'Uso de Datos',
        dataUsageDescription: 'Configurar el uso de datos móviles',
        themes: {
          light: 'Claro',
          dark: 'Oscuro',
          auto: 'Automático'
        },
        dataUsageOptions: {
          low: 'Bajo',
          medium: 'Medio',
          high: 'Alto'
        }
      },
      security: {
        title: 'Configuración de Seguridad',
        twoFactorEnabled: 'Autenticación de Dos Factores',
        twoFactorEnabledDescription: 'Requerir código adicional para iniciar sesión',
        biometricEnabled: 'Autenticación Biométrica',
        biometricEnabledDescription: 'Usar huella dactilar o Face ID',
        sessionTimeout: 'Tiempo de Sesión',
        sessionTimeoutDescription: 'Tiempo antes de cerrar sesión automáticamente',
        loginNotifications: 'Notificaciones de Inicio de Sesión',
        loginNotificationsDescription: 'Recibir notificaciones cuando inicies sesión',
        accountActions: 'Acciones de Cuenta',
        exportData: 'Exportar Datos',
        exportDataDescription: 'Descargar todos tus datos personales',
        deleteAccount: 'Eliminar Cuenta',
        deleteAccountDescription: 'Eliminar permanentemente tu cuenta y todos los datos',
        export: 'Exportar',
        delete: 'Eliminar',
        minutes: 'minutos',
        hour: 'hora',
        hours: 'horas'
      },
      error: {
        loading: 'Error al cargar la configuración',
        updating: 'Error al actualizar la configuración',
        passwordMismatch: 'Las contraseñas no coinciden',
        passwordTooShort: 'La contraseña debe tener al menos 6 caracteres',
        passwordChange: 'Error al cambiar la contraseña',
        dataExport: 'Error al exportar los datos',
        accountDeletion: 'Error al eliminar la cuenta',
        notFound: 'Configuración no encontrada'
      },
      success: {
        updated: 'Configuración actualizada exitosamente',
        passwordChanged: 'Contraseña cambiada exitosamente',
        dataExported: 'Datos exportados exitosamente',
        accountDeleted: 'Cuenta eliminada exitosamente'
      },
      confirm: {
        accountDeletion: '¿Estás seguro de que quieres eliminar tu cuenta? Esta acción no se puede deshacer.'
      }
    },

    // Skills Management
    skills: {
      title: 'Gestión de Habilidades',
      addSkill: 'Agregar Habilidad',
      editSkill: 'Editar Habilidad',
      deleteSkill: 'Eliminar Habilidad',
      skillName: 'Nombre de la Habilidad',
      skillNamePlaceholder: 'Ej: Carpintería, Electricidad, Enfermería',
      skillDescription: 'Descripción',
      skillDescriptionPlaceholder: 'Describe tu experiencia en esta habilidad',
      skillLevel: 'Nivel',
      skillLevels: {
        beginner: 'Principiante',
        intermediate: 'Intermedio',
        advanced: 'Avanzado',
        expert: 'Experto'
      },
      skillCategory: 'Categoría',
      skillCategories: {
        technical: 'Técnico',
        soft: 'Blandas',
        safety: 'Seguridad',
        certification: 'Certificación',
        other: 'Otro'
      },
      yearsOfExperience: 'Años de Experiencia',
      yearsOfExperiencePlaceholder: '0',
      isCertified: '¿Tienes certificación?',
      certificationDetails: 'Detalles de Certificación',
      certificationDetailsPlaceholder: 'Describe tu certificación si aplica',
      addNewSkill: 'Agregar Nueva Habilidad',
      noSkills: 'No tienes habilidades registradas',
      noSkillsDescription: 'Agrega tus habilidades para mejorar tu perfil y recibir mejores ofertas de trabajo',
      saveSkill: 'Guardar Habilidad',
      cancel: 'Cancelar',
      delete: 'Eliminar',
      edit: 'Editar',
      view: 'Ver',
      searchSkills: 'Buscar habilidades...',
      filterByCategory: 'Filtrar por categoría',
      filterByLevel: 'Filtrar por nivel',
      allCategories: 'Todas las categorías',
      allLevels: 'Todos los niveles',
      skillAdded: 'Habilidad agregada exitosamente',
      skillUpdated: 'Habilidad actualizada exitosamente',
      skillDeleted: 'Habilidad eliminada exitosamente',
      error: {
        loading: 'Error al cargar las habilidades',
        adding: 'Error al agregar la habilidad',
        updating: 'Error al actualizar la habilidad',
        deleting: 'Error al eliminar la habilidad',
        notFound: 'Habilidad no encontrada'
      },
      validation: {
        nameRequired: 'El nombre de la habilidad es requerido',
        descriptionRequired: 'La descripción es requerida',
        levelRequired: 'El nivel es requerido',
        categoryRequired: 'La categoría es requerida',
        yearsRequired: 'Los años de experiencia son requeridos',
        yearsPositive: 'Los años de experiencia deben ser un número positivo'
      }
    },
    quotations: {
      title: 'Cotizaciones',
      addQuotation: 'Nueva Cotización',
      noQuotations: 'No hay cotizaciones registradas',
      quotationRegistered: 'cotización registrada',
      quotationsRegistered: 'cotizaciones registradas',
      filterByStatus: 'Filtrar por estado',
      showing: 'Mostrando',
      quotation: 'cotización',
      quotations: 'cotizaciones',
      withStatus: 'con estado',
      client: 'Cliente',
      noClient: 'Sin cliente',
      createdBy: 'Creado por',
      createdAt: 'Fecha de creación',
      system: 'Sistema',
      status: 'Estado',
      actions: 'Acciones',
      view: 'Ver',
      startCreatingMessage: 'Comienza creando tu primera cotización',
      createFirst: 'Crear primera cotización',
      sentQuotationsTable: 'Cotizaciones Enviadas',
      formBuilder: {
        title: 'Constructor de Formularios',
        formLink: 'Enlace del formulario',
        copy: 'Copiar enlace',
        copyEmbed: 'Copiar código embed',
        copied: 'Copiado al portapapeles'
      },
      assign: 'Asignar',
      assignQuotation: 'Asignar Cotización',
      selectEmployeeToAssign: 'Selecciona un empleado para asignar esta cotización:',
      employee: 'Empleado',
      selectEmployee: 'Selecciona un empleado',
      assignedSuccess: 'Cotización asignada exitosamente',
      assignedTo: 'Asignado a',
      notAssigned: 'Sin asignar',
      viewLog: 'Ver Log',
      activityLog: 'Registro de Actividad',
      noActivityYet: 'Sin actividad registrada',
      actionCreated: 'Creada',
      actionAssigned: 'Asignada',
      actionRead: 'Leída',
      actionSent: 'Enviada',
      actionConverted: 'Convertida',
      detailCreated: 'Cotización creada como borrador',
      detailAssigned: 'Asignada a {{employeeName}}',
      detailRead: 'Cotización abierta y marcada como leída',
      detailSent: 'Cotización marcada como enviada al cliente',
      detailConverted: 'Cotización convertida en proyecto',
      draftCreated: 'Borrador creado. Selecciona un cliente para continuar.'
    }
  }
};

export default es; 